import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { login as apiLogin } from "../utils/api";

// ==========================================
// AuthContext - Merkezi Kimlik Doğrulama
// localStorage ile kalıcılık sağlar.
// ==========================================

const AuthContext = createContext(null);

const STORAGE_KEY = "yerimhazir_user";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sayfa yenilemesinde localStorage'dan restore
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setUser(JSON.parse(stored));
      }
    } catch (err) {
      console.error("Auth restore hatası:", err);
      localStorage.removeItem(STORAGE_KEY);
    } finally {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (username, password) => {
    const userData = await apiLogin(username, password);
    setUser(userData);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
    return userData;
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  const value = {
    user,
    loading,
    login,
    logout,
    isLoggedIn: !!user,
    isAdmin: user?.role === "admin",
    isStaff: user?.role === "staff",
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

/**
 * Auth context hook
 * @returns {{ user: Object|null, loading: boolean, login: Function, logout: Function, isLoggedIn: boolean, isAdmin: boolean, isStaff: boolean }}
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
